import { createSelector } from 'reselect';
import { getProp } from '../../utilities';

const userDomainSelector = state => state.user;

export const userDetailSelector = createSelector(userDomainSelector, user => {
  return getProp(user, ['data'], null);
});

export const userDetailIsFetchingSelector = createSelector(
  userDomainSelector,
  user => {
    return getProp(user, ['isFetching'], false);
  },
);



// WEBPACK FOOTER //
// ./src/containers/Login/selectors.js